module.exports = __webpack_public_path__ + "ce6979add9b9e2ed695ef5e3da42aff1.pdf";